import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-admuser-list',
  templateUrl: './admuser-list.component.html',
  styleUrl: './admuser-list.component.scss'
})
export class AdmuserListComponent implements OnInit {

  result: any;
  users: any;
  msg: Message = null;

  filteredUsers: any[] = [];
  availableRoles: string[] = [];

  filters = {
    searchText: '',
    role: '',
    status: null as boolean | null
  };

  constructor(
    private usersService: UsersService
  ) { }

  ngOnInit() {
    this.loadInfoALLUser();
  }

  loadInfoALLUser() {
    this.usersService.getUsers().subscribe({
      next: res => {
        this.result = res
        this.users = res['data'];
        this.filteredUsers = this.users;
        this.extractAvailableRoles();
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  extractAvailableRoles() {
    let uniqueRoles: string[] = [];
    this.users
      .flatMap((user) => user.roles)
      .filter((role) => role && role.label)
      .map((role) => String(role.label).trim())
      .forEach((role) => {
        if (!uniqueRoles.includes(role)) {
          uniqueRoles.push(role);
        }
      });
    this.availableRoles = uniqueRoles;
  }


  applyFilter(): void {
    this.filteredUsers = this.users.filter(user =>
      (this.filters.searchText
        ? (
          `${user.person.name} ${user.person.lastname}`.toLowerCase().includes(this.filters.searchText.toLowerCase()) ||
          user.email.toLowerCase().includes(this.filters.searchText.toLowerCase())
        )
        : true) &&
      (this.filters.role ? (user.roles[0]?.label || 'sin asignar') === this.filters.role : true) &&
      // Filtro por estado
      (this.filters.status !== null ? user.isActive === this.filters.status : true)
    );
  }

  sendId = {}
  /* Metodo para eliminar un usuario -> eliminación logico */
  deleteUserAccess(id1: string, m1: string) {
    this.sendId['id'] = id1
    if (confirm('Esta seguro que desea quitar el acceso al usuario ' + m1)) {
      this.usersService.deleteUser(this.sendId).subscribe({
        next: res => {
          this.loadInfoALLUser();
          console.log(res);
        },
        error: err => {
          console.error(err)
        }
      });
    }
  }
  /* Metodo para dar privilegios a  un usuario */
  grantedUserAccess(id1: string, m1: string) {
    this.sendId['id'] = id1
    if (confirm('Esta seguro que desea otorgar el acceso al usuario ' + m1)) {
      this.usersService.grantedUser(this.sendId).subscribe({
        next: res => {
          this.loadInfoALLUser();
          console.log(res);
        },
        error: err => {
          console.error(err)
        }
      });
    }
  }

}
